// extracted by mini-css-extract-plugin
export default {"switcher-popover-trigger-clickable":"o8NXlLEVysQIaYoNiIZo","switcher-popover-trigger-text":"jP2lwql6pwJyDzKfmhgA"};